<template>
    <div class="main">
        <div class="body-content">
            <h1>Bill Register</h1>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <select id="partyname" v-model="newContainer.partyName" class="custom-select" style="width:100%">
                        <option value="0">Select Party</option>
                        <option v-for="party in party" :key="party.autoid" :value="party.autoid">
                            {{ party.short_name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="fromdate">From Date </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsDate()" style="width:100%" />
                </div>
                <div class="form-item">
                    <label for="todate">To Date </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsToDate()" style="width:100%" />
                </div>
            </div>
            <div>
                <button type="button" class="excel-button" @click="populate_data" :disabled="isSubmitting">Sale Bill Display</button>
                <button type="button" class="excel-button" @click="ova_report" :disabled="isSubmitting">Sale Bill Excel</button>
            </div>
            <div class="table-container">
                <table class="transaction-table table-design">
                    <tbody>
                        <tr v-for="(transaction) in transactions" :key="transaction[0]">
                            <td>{{ transaction[0] }}</td>
                            <td>{{ transaction[1] }}</td>
                            <td>{{ transaction[2] }}</td>
                            <td>{{ transaction[3] }}</td>
                            <td>{{ transaction[4] }}</td>
                            <td>{{ transaction[5] }}</td>
                            <td>{{ transaction[6] }}</td>
                            <td>{{ transaction[7] }}</td>
                            <td>{{ transaction[8] }}</td>
                            <td>{{ transaction[9] }}</td>
                            <td>{{ transaction[10] }}</td>
                            <td>{{ transaction[11] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'
//import { saveAs } from 'file-saver';
export default {
    data() {
        return {
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            isSubmitting: false,
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                fromdate: '',
                todate: '',
            },
        }
    },
    methods: {
        checkIsDate() {
            if (this.newContainer.fromdate != '') {
                if (cs.isvalidDate(this.newContainer.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.newContainer.todate != '') {
                if (cs.isvalidDate(this.newContainer.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        async populate_data() {
            if (this.isSubmitting) return;
            
            if (!this.newContainer.fromdate.trim()) {
                useToast().error('From date is required.');
                return;
            }
            
            // Validate date format
            if (!cs.isvalidDate(this.newContainer.fromdate)) {
                useToast().error('Invalid From Date format. Please use dd/mm/yyyy.');
                return;
            }
            
            if (this.newContainer.todate && !cs.isvalidDate(this.newContainer.todate)) {
                useToast().error('Invalid To Date format. Please use dd/mm/yyyy.');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                this.updateApplicantAccountIds(this.newContainer.partyName);
                
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                
                var fromDt = '';
                var toDt = '';
                if (this.newContainer.fromdate != '') {
                    fromDt = cs.ConvertToISODate(this.newContainer.fromdate);
                }
                if (this.newContainer.todate != '') {
                    toDt = cs.ConvertToISODate(this.newContainer.todate);
                }
                
                const response = await axios.get('/populate_salebillregisterdata?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&fromdate=' + fromDt + '&todate=' + toDt, config);
                
                console.log(response);
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transactions = response.data[2];
                }
            } catch (error) {
                console.error('Error populating bill data:', error);
                useToast().error(error.response?.data?.message || 'Error loading bill data.');
            } finally {
                this.isSubmitting = false;
            }
        },
        async ova_report() {
            if (this.isSubmitting) return;
            
            if (!this.newContainer.fromdate.trim()) {
                useToast().error('From date is required.');
                return;
            }
            
            // Validate date format
            if (!cs.isvalidDate(this.newContainer.fromdate)) {
                useToast().error('Invalid From Date format. Please use dd/mm/yyyy.');
                return;
            }
            
            if (this.newContainer.todate && !cs.isvalidDate(this.newContainer.todate)) {
                useToast().error('Invalid To Date format. Please use dd/mm/yyyy.');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                this.updateApplicantAccountIds(this.newContainer.partyName);
                
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                
                var fromDt = '';
                var toDt = '';
                if (this.newContainer.fromdate != '') {
                    fromDt = cs.ConvertToISODate(this.newContainer.fromdate);
                }
                if (this.newContainer.todate != '') {
                    toDt = cs.ConvertToISODate(this.newContainer.todate);
                }
                
                const response = await axios.get('/populate_salebillregisterxl?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&fromdate=' + fromDt + '&todate=' + toDt, config);
                
                console.log(response);
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transactions = [];
                }
            } catch (error) {
                console.error('Error generating Excel report:', error);
                useToast().error(error.response?.data?.message || 'Error generating Excel report.');
            } finally {
                this.isSubmitting = false;
            }
        },
    }
}

</script>
<style scoped>
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 31%;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.excel-button:disabled:hover {
    background-color: #6c757d;
}
</style>